import api from "./api";


export const getEnterprisesWithoutSubscription = async (search = '') => {
  try {
    const response = await api.get(`enterprise/without-subscription`, {
      params: { search }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresas sem assinatura:", error);
    return [];
  }
};

/**
 * Cria uma nova enterprise com um admin específico.
 * @param {object} enterpriseData - Os dados do formulário.
 */
export const createEnterprise = async (enterpriseData) => {
  try {
    const response = await api.post(
      "enterprise/with-specific-admin",
      enterpriseData
    );
    return response.data; // Retorna os dados da empresa criada em caso de sucesso
  } catch (error) {
    console.error(
      "Erro ao criar a empresa:",
      error.response?.data?.message || error.message
    );
    return null;
  }
};

export const getEnterpriseById = async (id) => {
  try {
    const response = await api.get(`enterprise/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar os detalhes da empresa:",
      error.response?.data?.message || error.message
    );
    return null;
  }
};


/**
 * Busca a lista de todas as empresas cadastradas.
 * Apenas usuários 'House' podem acessar.
 */
export const getAllEnterprises = async (params) => {
  try {
    const response = await api.get("enterprise", { params });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar as empresas:", error);
    return null;
  }
};

/**
 * Busca o sumário de todas as assinaturas (valores, contagens, etc.).
 * Apenas usuários 'House' podem acessar.
 */
export const getSubscriptionSummary = async () => {
  try {
    const response = await api.get("subscription/summary");
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o sumário de assinaturas:", error);
    return null;
  }
};

/**
 * Atualiza os detalhes de contato e endereço de uma enterprise.
 * @param {number} id - O ID da enterprise a ser atualizada.
 * @param {object} enterpriseData - Os dados atualizados.
 */
export const updateEnterpriseDetails = async (id, enterpriseData) => {
  try {
    const response = await api.put(`enterprise/${id}/details`, enterpriseData);
    console.log(response)
    return response.data; // Retorna os dados da empresa atualizada
  } catch (error) {
    console.log(error)
    console.error(
      "Erro ao atualizar os detalhes da empresa:",
      error.response?.data?.message || error.message
    );
    return null;
  }
};

/**
 * Busca os detalhes da assinatura de uma enterprise específica.
 * @param {number} enterpriseId - O ID da enterprise.
 */
export const getSubscriptionByEnterpriseId = async (enterpriseId) => {
  try {
    const response = await api.get(`subscription/enterprise/${enterpriseId}`);
    console.log(response)
    return response.data;
  } catch (error) {
    // Se o erro for 404 (Not Found), não é um erro crítico, apenas não há assinatura.
    if (error.response && error.response.status === 404) {
      return null;
    }
    console.error("Erro ao buscar a assinatura da empresa:", error.response?.data?.message || error.message);
    return null; // Retorna null em caso de erro para o componente lidar
  }
};
